import { render, staticRenderFns } from "./protectionismD.vue?vue&type=template&id=3255a11e"
import script from "./protectionismD.vue?vue&type=script&lang=js"
export * from "./protectionismD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports